import 'date-fns';
import React from 'react';
import _ from 'lodash';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import images from 'assets/images';

const FormikDatePicker = ({ field: { ...fields }, form: { touched, errors }, ...props }): React.ReactNode => {
    const { onChange, hasObject = false, isDateOnly = false, ...rest } = props;
    const error = Boolean(_.get(touched, fields.name) && _.get(errors, fields.name));

    const handleChange = (date: MaterialUiPickersDate) => {
        if (!date) {
            if (onChange) {
                onChange(null);
            }
            return;
        }

        const normalizedDate = new Date(date);
        normalizedDate.setHours(0, 0, 0, 0);

        const year = normalizedDate.getFullYear();
        const month = String(normalizedDate.getMonth() + 1).padStart(2, '0');
        const day = String(normalizedDate.getDate()).padStart(2, '0');
        const localDateString = `${year}-${month}-${day}T00:00:00`;

        if (onChange) onChange(isDateOnly ? localDateString : date);
    };

    const getError = () => {
        let errorString = errors;
        fields?.name?.split('.').map((name) => (errorString = errorString[name]));
        return errorString;
    };
    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
                {...fields}
                {...rest}
                className="custom-datepicker"
                inputVariant="outlined"
                views={['year', 'month', 'date']}
                format="MM/dd/yyyy"
                placeholder="MM/dd/yyyy"
                autoOk={true}
                error={error}
                helperText={error && (hasObject ? getError() : errors[fields?.name])}
                name={fields.name}
                value={fields.value}
                onChange={handleChange}
                keyboardIcon={<img src={images.datepicker} alt="Date" />}
                // InputProps={{ readOnly: true }}
            />
        </MuiPickersUtilsProvider>
    );
};
export default FormikDatePicker;
